<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getPagination('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getPagination('page')"
  [sort]="getPagination('sort')"
  [orderBy]="getPagination('order_by')"
  [columns]="columns"
  [showDownload]="true"
  [showFilter]="true"
  [showReload]="true"
  (download)="handleDownload()"
  (onFilterChange)="handleFilterChange($event)"
  [filters]="filters"
  class="is-block mt-2"
>
  <ng-template let-row="row" let-index="index" #appealReason>
    <div class="dots-wrapper" *ngIf="!!row.get('appealReason')">
      <span
        class="dots"
        [options]="{ placement: 'left' }"
        [tooltip]="row.get('appealReason')"
        tooltipClass="white-tooltip"
        theme="light"
        [animationDuration]="0"
        [hideDelay]="0"
        >...</span
      >
    </div>
  </ng-template>
  <ng-template let-row="row" #appealNote>
    <div class="dots-wrapper" *ngIf="!!row.get('appealNote')">
      <span
        class="dots"
        [options]="{ placement: 'left' }"
        [tooltip]="row.get('appealNote')"
        tooltipClass="white-tooltip"
        theme="light"
        [animationDuration]="0"
        [hideDelay]="0"
        >...</span
      >
    </div>
  </ng-template>

  <ng-template #addonLeft>
    <div
      class="buttons m-0"
      *ngIf="type === 'property_register' || type === 'data_entry'"
    >
      <a
        [routerLink]="['/properties/create/details']"
        class="button is-small is-info disabled mb-0"
        translationEditableDirective="CREATE_PROPERTY"
        >{{ 'CREATE_PROPERTY' | translate }}</a
      >
    </div>
  </ng-template>
  <ng-template let-row="row" #idColumn>
    <div class="buttons">
      <a [routerLink]="['/properties/', row.get('id')]">{{
        row.get('propertyCodeAssigned')
      }}</a>
    </div>
  </ng-template>
  <ng-template let-row="row" #status>
    <span
      class="tag is-black"
      [ngStyle]="{
        width: '120px',
        background: statusColor[row.getIn(['status', 'name'])]
      }"
      [translationEditableDirective]="row.getIn(['status', 'title'])"
    >
      {{ row.getIn(['status', 'title']) | translate }}
    </span>
  </ng-template>
  <ng-template let-row="row" #assessibility>
    <span
      [translationEditableDirective]="
        row.getIn(['assessibility', 'translationKey'])
      "
      >{{
        row.getIn(['assessibility', 'translationKey'])
          | translate : { defaultValue: row.getIn(['assessibility', 'title']) }
      }}</span
    >
  </ng-template>
  <ng-template let-row="row" #plusCode>
    <div class="buttons">
      <a target="_blank" [href]="'https://plus.codes/' + row.get('plusCode')">{{
        row.get('plusCode')
      }}</a>
    </div>
  </ng-template>
</app-table>
